<template>
    <div class="bg-gray-800 text-white shadow-lg rounded-lg w-full p-8">
        <h2 class="text-2xl mb-6">Partner Portal</h2>
        <form @submit.prevent="Login">
            <div class="form-control mb-4">
                <label for="username" class="label">Email</label>
                <div class="flex items-center border border-gray-600 rounded-lg bg-gray-700 px-3 py-2">
                    <i class="bi bi-person text-gray-400 text-lg mr-2"></i>
                    <input type="text" id="username" v-model="username" placeholder="Enter your email"
                        class="bg-transparent text-white w-full border-0 focus:ring-0 focus:outline-none" required />
                </div>
            </div>
            <div class="form-control mb-4">
                <label for="password" class="label">Password</label>
                <div class="flex items-center border border-gray-600 rounded-lg bg-gray-700 px-3 py-2">
                    <i class="bi bi-lock text-gray-400 text-lg mr-2"></i>
                    <input type="password" id="password" v-model="password" placeholder="Enter your password"
                        class="bg-transparent text-white w-full border-0 focus:ring-0 focus:outline-none" required />
                </div>
            </div>
            <p v-if="errorMessage" class="text-red-500 text-sm mt-2">{{ errorMessage }}</p>
            <button type="submit" class="bg-indigo-600 hover:bg-indigo-700 text-white py-2 rounded-lg w-full mt-4">Login</button>
        </form>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        apiUrl: String,
        accessToken: String,
        idToken: String,
        refreshToken: String
    },
    data() {
        return {
            username: '',
            password: '',
            errorMessage: ''
        };
    },
    methods: {
        Login() {
            const url = `${this.apiUrl}/user/login`;
            this.$emit("clear-error"); 

            axios.post(url, { username: this.username, password: this.password })
                .then(response => {
                    if (response.data.message === 'NEW_PASSWORD_REQUIRED') {
                        this.$emit("new-password-required", response.data.session, this.username);
                    } else {
                        this.$emit("set-tokens", response.data.access_token, response.data.id_token, response.data.refresh_token);
                    }
                })
                .catch(error => {
                    this.errorMessage = "Invalid username or password";
                    console.error(error);
                });
        }
    }
};
</script>
